/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScanMessageEventDto } from '../../models/scan-message-event-dto';

export interface CaptureTokenControllerStream$Params {
  id: number;
}

export function captureTokenControllerStream(http: HttpClient, rootUrl: string, params: CaptureTokenControllerStream$Params, context?: HttpContext): Observable<StrictHttpResponse<ScanMessageEventDto>> {
  const rb = new RequestBuilder(rootUrl, captureTokenControllerStream.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScanMessageEventDto>;
    })
  );
}

captureTokenControllerStream.PATH = '/api/capture-tokens/{id}/stream';
